import { render } from "./EducationDetail.vue?vue&type=template&id=e5d15abc&scoped=true"
import script from "./EducationDetail.vue?vue&type=script&lang=js"
export * from "./EducationDetail.vue?vue&type=script&lang=js"

import "./EducationDetail.vue?vue&type=style&index=0&id=e5d15abc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1372789139/src/portfolio-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d15abc"]])

export default __exports__